export function getListingByState(state, listings = []) {
  return listings.filter(listing => listing.attributes.state === state);
}
